import { useTranslation } from 'react-i18next';

interface EnLocaleWrapperProps {
  children: React.ReactNode;
  inverted?: boolean;
  fallback?: React.ReactNode;
}

/**
 * 로케일이 영어(en, en-US, en-GB 등)인지에 따라 children 또는 fallback을 조건부 렌더링하는 컴포넌트.
 *
 * @param children - 조건 충족 시 표시할 내용
 * @param inverted - true(기본): 영어가 아니면 children 표시. false: 영어일 때만 children 표시
 * @param fallback - 조건 미충족 시 표시할 내용. 미지정 시 null
 */
const EnLocaleWrapper = ({ children, inverted = true, fallback = null }: EnLocaleWrapperProps) => {
  const { i18n } = useTranslation();

  const isEnLocale = i18n.language?.startsWith('en') ?? false;
  const shouldShow = inverted ? !isEnLocale : isEnLocale;
  console.log(i18n.language);

  if (shouldShow) {
    return <>{children}</>;
  }
  return <>{fallback}</>;
};

export default EnLocaleWrapper;
